export default __webpack_public_path__ + "static/media/google-g.25d7f4f6.png";